module.exports = __webpack_public_path__ + "static/banner-liquid-23e70d71783387aeebb9d63a32664446.png";